export default "__VITE_ASSET__a9w3a2By__"